import { action, observable } from 'mobx';
// modules
import FormatService from 'modules/Format/service';
// typings
import { Holding } from 'modules/TradesPW3/Holdings/typings';
import { SegmentType } from 'modules/Search/constants';

export default class HoldingsStore {
  @observable holdings: Holding[] = [];

  @action setHoldings = (holdings: Holding[]) => {
    this.holdings = holdings;
  };

  static generateHoldingExchangeTokens(
    holding: Pick<Holding, 'token_nse' | 'token_bse'>,
  ) {
    return {
      nseToken: holding.token_nse
        ? FormatService.generateExchangeToken(
          SegmentType.NSE_EQ, holding.token_nse,
        )
        : '',
      bseToken: holding.token_bse
        ? FormatService.generateExchangeToken(
          SegmentType.BSE_EQ, holding.token_bse,
        )
        : '',
    };
  }

  static getPrimaryExchangeToken(holding: Holding) {
    const exchangeTokens = HoldingsStore.generateHoldingExchangeTokens(holding);
    return exchangeTokens.nseToken || exchangeTokens.bseToken;
  }

  static getPrimaryInstrumentKey(holding: Holding) {
    return holding.instrumentKeyNSE || holding.instrumentKeyBSE;
  }

  static getTvExchangeToken(holding: Holding) {
    return (
      holding.tvExchangeTokenNSE ||
      holding.tvExchangeTokenBSE ||
      holding.instrument?.[0]?.s
    );
  }
}
